import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import Header from './Components/Header';
import Home from './Components/Home';
import WebDesignDevelopment from './Components/WebDesignDevelopment';
import MobileAppDevelopment from './Components/MobileAppDevelopment';
import DigitalMarketing from './Components/DigitalMarketing';
import InfrastructureDevelopment from './Components/InfrastructureDevelopment';
import ApplicationDevelopment from './Components/ApplicationDevelopment';
import ProcessOutsourcing from './Components/ProcessOutsourcing';
import CloudMigration from './Components/CloudMigration';
import DataIntegration from './Components/DataIntegration';
import MainframeComputing from './Components/MainframeComputing';
import ProductEngineering from './Components/ProductEngineering';
import CustomerExperienceCPQ from './Components/CustomerExperienceCPQ';
import SupplyChainOptimization from './Components/SupplyChainOptimization';
import BigDataAnalytics from './Components/BigDataAnalytics';
import MobilityAndUX from './Components/MobilityAndUX';
import AIAndML from './Components/AIAndML';
import SAPEnterpriseSystems from './Components/SAPEnterpriseSystems';
import SalesforcePlatforms from './Components/SalesforcePlatforms';
import MicrosoftCloudSolutions from './Components/MicrosoftCloudSolutions';
import AWSCloudSolutions from './Components/AWSCloudSolutions';
import ManufacturingSolutions from './Components/ManufacturingSolutions';
import HealthcareAndBiotech from './Components/HealthcareAndBiotech';
import AutomotiveSolutions from './Components/AutomotiveSolutions';
import MediaAndEntertainment from './Components/MediaAndEntertainment';
import AboutUs from './Components/AboutUs';
import Footer from './Components/Footer';
import ContactUs from './Components/ContactUs';

const App = () => {
  return (
    <BrowserRouter>
      {/* Header stays inside BrowserRouter so navigation links work everywhere */}
      <ScrollToTop />
      <Header /> 

      {/* Replaced <Router> with <Routes> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/design-and-development' element={<WebDesignDevelopment />} />
        <Route path="/mobile-app-development" element={<MobileAppDevelopment />} />
        <Route path="/digital-marketing" element={<DigitalMarketing />} />
        <Route path='/infrastructure-development' element={<InfrastructureDevelopment />} />
        <Route path='/application-development' element={<ApplicationDevelopment />} />
        <Route path='/process-outsourcing' element={<ProcessOutsourcing />} />
        <Route path='/cloud-migration' element={<CloudMigration />} />
        <Route path='/data-integration' element={<DataIntegration />} />
        <Route path='/mainframe-computing' element={<MainframeComputing />} />
        <Route path='/product-engineering' element={<ProductEngineering />} />
        <Route path='/customer-experience-cpq' element={<CustomerExperienceCPQ />} />
        <Route path='/supply-chain-optimization' element={<SupplyChainOptimization />} />
        <Route path='/big-data-analytics' element={<BigDataAnalytics />} />
        <Route path='/mobility-and-ux' element={<MobilityAndUX />} />
        <Route path='/ai-and-ml' element={<AIAndML />} />
        <Route path='/sap-enterprise-systems' element={<SAPEnterpriseSystems />} />
        <Route path='/salesforce-platforms' element={<SalesforcePlatforms />} />
        <Route path='/microsoft-cloud-solutions' element={<MicrosoftCloudSolutions />} />
        <Route path='/aws-cloud-solutions' element={<AWSCloudSolutions />} />
        <Route path='/manufacturing-solutions' element={<ManufacturingSolutions />} />
        <Route path='/healthcare-biotech-solutions' element={<HealthcareAndBiotech />} />
        <Route path='/automotive-solutions' element={<AutomotiveSolutions />} />
        <Route path='/media-and-entertainment' element={<MediaAndEntertainment />} />
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/contact' element={<ContactUs />} />
        
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;